import { _createSelector } from 'util/selectorUtils';
import { extractSimplrTagsForSelectedTicket } from 'extractFromState';

export const extractSimplrTags = _createSelector(
  [extractSimplrTagsForSelectedTicket],
  (simplrCategories) => simplrCategories?.categories || []
);
